import React, { useState, } from "react";
import { Link } from "react-router-dom"; // Or 'next/link' if Next.js
import { useCountry } from './../CountryContext';
import ReportsSection from "../../components/ReportDropdown7"

const Solutions = () => {
  // Register chart.js components
const SMMEsOptions = [
  {
    "heading": "Smallholder Commercial Farms",
    "items": [
      {
        "label": "Small-scale farms operating for profit. Use improved inputs, some mechanization, and sell surplus to local markets. Often family-run but may hire seasonal labor. Example: A 5-hectare maize farm using hybrid seeds and selling to a local mill.",
        "value": "ESC"
      }
    ]
  },
  {
    "heading": "Medium-Scale Farms",
    "items": [
      {
        "label": "Larger landholding than smallholders (e.g., 10–100 hectares). Often mechanized and more capitalized. Supply supermarkets, processors, or export markets. Example: A 50-hectare rice farm with irrigation and a tractor, selling to a national rice brand.",
        "value": "EMS"
      }
    ]
  },
  {
    "heading": "Farmer Cooperatives / Producer Organizations",
    "items": [
      {
        "label": "Groups of farmers who pool resources to gain market power. May own equipment, storage, or transport collectively. Can register as SMEs and operate commercially. Example: A cooperative of 100 tomato farmers owning a cold storage unit.",
        "value": "EFC"
      }
    ]
  },
  {
    "heading": "Contract Farming SMEs",
    "items": [
      {
        "label": "Farmers or farm groups under formal agreements to supply crops/livestock to processors or exporters. Often receive inputs and training from buyers. Example: Poultry farmers supplying eggs to a food company under a contract.",
        "value": "ECF"
      }
    ]
  },
  {
    "heading": "Niche or Specialized Farms",
    "items": [
      {
        "label": "Farms focused on high-value or specialized production: Organic farms, Horticulture farms (vegetables, flowers, herbs), Aquaculture enterprises, Livestock or poultry SMEs, Beekeeping and honey production. Example: A small farm producing organic herbs for export.",
        "value": "ENS"
      }
    ]
  },
  {
    "heading": "Agri-Entrepreneurs with Integrated Operations",
    "items": [
      {
        "label": "These SMEs farm and also manage part of the value chain, such as: On-farm processing (e.g., dairy to yogurt), Direct-to-consumer sales (farm shops, online orders). Example: A mushroom farmer selling pre-packed mushrooms to urban grocers.",
        "value": "EAE"
      }
    ]
  },
  {
    "heading": "Youth or Women-led Farming Startups",
    "items": [
      {
        "label": "Often tech-savvy and innovative. Use climate-smart or digital farming tools. May focus on urban/peri-urban agriculture. Example: A woman-led hydroponic vegetable farm near a city.",
        "value": "EYW"
      }
    ]
  },
]
 const { selectedCountry } = useCountry();
 const [reportSelections, setReportSelections] = useState({
     COUNTRY: "-",
     REGION: "-",
     DISTRICT: "-",
     MUNICIPALITY: "-",
     SMMEs: "-",
     "VALUE CHAIN": "-",
     PROJECT: "-",
     "USER TYPE": "-"
   });

  const handleReportDropdownChange = (type, value) => {
    setReportSelections(prev => {
      const newSelections = {
        ...prev,
        [type]: value
      };
      
      if (type === 'COUNTRY') {
        newSelections.REGION = "-";
        newSelections.DISTRICT = "-";
        newSelections.MUNICIPALITY = "-";
      }
      
      return newSelections;
    });
  };
  return (
    <div className="bg-white md:pt-5 mt-2 pb-2 md:pb-5 pt-3">
      <div className="md:px-20 px-4">
        <div className="flex justify-between items-center">
          <h2 className="md:text-[36px] text-[10px] capitalize text-[#152C24] font-bold">
            <span className="text-[#979797] capitalize">SERVICES | </span>{selectedCountry?.name || 'South Africa'}
          </h2>
          <div>
            <h1 className="md:text-[20px] text-[8px] font-extrabold md:mb-2">USER NUMBER</h1>
            <div className="flex w-fit">
              <button
                className={`xl:w-[250px] lg:w-[160px] md:w-[90px] w-[70px] h-[25px] md:h-[53px] bg-[#152C24] text-white font-medium flex items-center px-1 rounded-l-[5px]`}>
                <input className="md:text-[18px] text-[8px] md:px-2 bg-transparent outline-none placeholder-white" placeholder="XXXXXXXXX"/>
              </button>
              <div
                className="w-[20px] h-[25px] md:h-[53px] md:w-[50px] bg-[#EEB527] text-white flex justify-center items-center rounded-r-[5px] -ml-2 z-30 cursor-pointer"
              >
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1747251939/Expand_right_wbmjno.png"
                  alt="expand"
                  className="w-3 h-[12px] md:w-6 md:h-[24px]"
                />
              </div>
            </div>
            <p className="md:text-[14px] text-[8px] font-normal mt-1 text-black">
              Insert ID Number
            </p>
          </div>
        </div>
        
        <ReportsSection
          values={reportSelections}
          onChange={handleReportDropdownChange}
          smmesOptions={SMMEsOptions}
        />

<div className="relative w-full h-[150px] md:h-[650px]">
  {/* Background image */}
  <img
    src="https://res.cloudinary.com/dzngpgki4/image/upload/v1752181533/image_cfgzfq.png"
    alt="Securing Agriculture in Namibia"
    className="w-full h-full object-cover md:rounded-lg rounded-md transition-opacity duration-500"
  />
  
  {/* Overlay icon centered */}
  <div className="absolute inset-0 flex items-center justify-center">
    <img
      src="https://res.cloudinary.com/dzngpgki4/image/upload/v1743776596/image_1502_utmsek.png"
      alt="Farm icon"
      className="w-16 h-16 md:w-32 md:h-32 object-contain"
    />
  </div>
</div>
        
        <div className="md:mt-6 mt-4">
          {/* Header with time */}
          <div className="flex items-start justify-between mb-4">
            <div className="md:text-[32px] text-[10px] text-[#979797] font-bold">
              ADVISORY | <span className="text-black"> Production - Yields</span>
            </div>
            <div>
              <p className="md:text-[24px] text-[8px] font-normal md:ml-10">April 13, 2025</p>
              <div className="flex items-center md:text-[24px] text-[8px] text-[#155528] font-normal">
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1752158165/Time_progress_light_sufu81.png"
                  alt="Time"
                  width={16}
                  height={16}
                  className="mr-1 md:mr-2 md:w-6 md:h-6"
                />
                2 Minutes read
              </div>
            </div>
          </div>
          <h1 className="md:text-[32px] text-[10px] font-semibold text-black mb-2">
          PRODUCTION
          </h1>

          {/* Main Title */}
          <h1 className="md:text-[32px] text-[10px] font-normal text-black mb-2">
          📢 Boost Your Yields with Expert Advice
          </h1>

          {/* Message */}
          <p className="text-black md:text-[32px] text-[8px] mb-4 md:mt-6 md:mb-6 leading-relaxed">
            Dear Farmer,
            <br />
            Accessing advisory services through the Farmnet App can help you:
          </p>

          {/* Benefits */}
          <div className="space-y-1 md:space-y-2 md:text-[32px] text-[8px]">
            <div className="flex items-start">
              <span className="text-green-600 mr-2">✅</span>
              <p>Improve your crop and livestock production</p>
            </div>
            <div className="flex items-start">
              <span className="text-green-600 mr-2">✅</span>
              <p>Reduce losses from pests, diseases, and poor practices</p>
            </div>
            <div className="flex items-start">
              <span className="text-green-600 mr-2">✅</span>
              <p>Make informed decisions on planting, input use, and harvesting</p>
            </div>
            <div className="flex items-start">
              <span className="text-green-600 mr-2">✅</span>
              <p>Increase your income through better planning and market timing</p>
            </div>
          </div>

          {/* Call to Action */}
          <div className="mt-6 md:mt-8 md:text-[32px] text-[8px]">
            <div className="flex items-start">
              <span className="mr-2">🧑‍🌾</span>
              <p>Don't farm alone—let expert knowledge guide you.</p>
            </div>
            <p className="mt-2 font-medium">Visit the Advisory section in your Farmnet App today and get tips tailored to your farm.</p>
            <p className="font-medium">Smart farming starts with smart advice!</p>
          </div>
          
          <div className="flex justify-between items-center mt-6 md:mt-12">
            <div className="flex gap-1 md:gap-2 items-center">
              <h1 className="md:text-[24px] text-[8px] font-normal">Reviews & Ratings</h1>
              <img src="https://res.cloudinary.com/dzngpgki4/image/upload/v1752159820/image_1786_qgnngy.png" alt="link" className="w-[16px] h-[16px] md:w-[48px] md:h-[48px]"/>
            </div>
            <div className="flex gap-1 md:gap-2 items-center">
              <h1 className="md:text-[24px] text-[8px] font-normal">WhatsApp us</h1>
              <img src="https://res.cloudinary.com/dzngpgki4/image/upload/v1752160024/image_1785_bsrl4k.png" alt="link" className="w-[16px] h-[16px] md:w-[48px] md:h-[48px]"/>
            </div>
           </div>
        </div>
      </div>

      <div className="md:h-8 h-4"></div>
    </div>
  );
};

export default Solutions;